<template>
  <div>
    <div class="input-phone-groups" :class="isPhoneValid ? '' : 'error-border'">
      <label>{{ title }}</label>
      <vue-tel-input
        v-model="value.number"
        enabledFlags
        required
        autoFormat
        :autoDefaultCountry="!isEdit"
        :defaultCountry="`${country}`"
        mode="national"
        enabledCountryCode
        dynamicPlaceholder
        :validCharactersOnly="false"
        :hide-details="false"
        :tabindex="tabindex"
        v-bind="bindProps"
        :autocomplete="'off'"
        class="custom-phone mx-2"
        :preferredCountries="preferredCountries"
        v-on:country-changed="handleOnSelectCountryCode"
        v-on:validate="handleOnValidate"
        v-if="!isLoading"
        :loading="isLoading"
      />
      <div v-if="!hideOptions">
        <v-chip outlined small class="primary-tag primary-number-tag phone-label" v-if="isPhonePrimary">
          {{ $t("primary_number") }}
        </v-chip>
        <v-menu offset-y v-if="!isPhonePrimary" :attach="attach">
          <template v-slot:activator="{ on, attrs }">
            <span class="dots" v-bind="attrs" v-on="on"> ... </span>
          </template>
          <v-list>
            <v-list-item @click="() => handleOnPhoneMakePrimary(index)">
              <v-list-item-title>{{ $t("make_primary") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="() => handleOnPhoneDeleted(value)">
              <v-list-item-title class="error--text">{{ $t("delete_number") }} </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div class="v-text-field__details" :class="!!errorMessage && 'd-block'">
      <div class="v-messages theme--light error--text pt-2" role="alert">
        <div class="v-messages__wrapper">
          <div class="v-messages__message">{{ errors }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhoneGroup",

  data() {
    return {
      phone: "",
      isValid: true,
      isLoading: true,
      preferredCountries: ["JO", "EG", "KW"],
      bindProps: {
        inputOptions: {
          showDialCode: false,
        },
      },
    };
  },

  props: {
    value: {
      type: [Number, Object, String],
      default: null,
    },

    index: {
      type: Number,
      default: 0,
    },

    errorMessage: {
      type: [Array, Object, String],
      default: null,
    },

    handleOnPhoneDeleted: {
      type: Function,
    },

    handleOnPhoneMakePrimary: {
      type: Function,
    },

    tabindex: {
      type: Number,
      default: 0,
    },

    hideOptions: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: false,
    },

    attach: {
      type: String,
      default: "",
    },

    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.isLoading = false;
      }, 200);
    });
  },

  computed: {
    /**
     * to check if the phone number valid or not
     * @return boolean
     */
    isPhoneValid() {
      return !this.errorMessage;
    },

    country() {
      return this.value?.country;
    },

    /**
     * to check if the phone number valid or not
     * @return boolean
     */
    isPhonePrimary() {
      return !!this.value.is_primary;
    },

    /**
     * Errors message
     * return {Array}
     */
    errors() {
      return this.errorMessage;
    },
  },

  methods: {
    /**
     * Select country code event
     */
    handleOnSelectCountryCode(data) {
      if (_.isObject(this.value) && !this.isLoading) {
        this.value.county_code = data.dialCode;
        this.value.country = data.iso2;
      }
    },

    /**
     * Validate phone number
     */
    handleOnValidate(data) {
      this.isValid = data.valid;

      if (window._.isObject(this.value)) {
        this.value["is_valid"] = data.valid;
      }
    },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
